import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { lockBodyScroll, unlockBodyScroll } from "../core/scroll-lock";

const ConfirmModal = ({
  isOpen,
  title = "Weet je het zeker?",
  message,
  confirmLabel = "Bevestigen",
  cancelLabel = "Annuleren",
  variant = "primary",
  busy = false,
  zIndex = 9999,
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape" && !busy) onCancel?.();
    };
    lockBodyScroll();
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      unlockBodyScroll();
    };
  }, [isOpen, busy, onCancel]);

  if (!isOpen) return null;

  const confirmClasses =
    variant === "danger"
      ? "bg-[#C9372C] hover:bg-[#AE2A19]"
      : "bg-brand hover:bg-brand-hover";

  const modal = (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-modal-title"
      style={{ position: "fixed", inset: 0, zIndex }}
      className="flex items-center justify-center p-4"
    >
      <div
        className="absolute inset-0 bg-[#091E428A]"
        onClick={() => {
          if (!busy) onCancel?.();
        }}
      />
      <div className="relative w-full max-w-md rounded-md bg-white shadow-overlay">
        <h3
          id="confirm-modal-title"
          className="px-6 pt-6 text-xl font-medium text-ink"
        >
          {title}
        </h3>
        {message ? (
          <p className="px-6 pt-3 text-sm text-ink">{message}</p>
        ) : null}
        <div className="flex justify-end gap-2 px-6 pb-6 pt-6">
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className="h-8 rounded bg-[#091E420F] px-3 text-sm font-medium text-ink hover:bg-[#091E4224] disabled:cursor-not-allowed disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className={`h-8 rounded px-3 text-sm font-medium text-white disabled:cursor-not-allowed disabled:opacity-50 ${confirmClasses}`}
          >
            {busy ? "Bezig..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
};

export default ConfirmModal;
